import React, { useEffect, useState } from 'react';
import styles from './Stats.module.scss';
import _ from 'lodash';
import { $t } from "helpers/translator";
import api from "helpers/api";
import { FadUsers, FaClinicMedical, FaSync, FaUserMd, FaPowerOff, FaTools, FaQuestionCircle, FaSignOutAlt, FaCog } from 'react-icons/fa';
import { Link } from 'react-router-dom';
const DistributorStats = ({dateRange}) => {
    const { startDate, endDate } = dateRange;
    const [ stats, setStats ] = useState({});
    const loadStats = async () => {
        const response = await api.get(`/dashboard/statistics?startDate=${startDate}&endDate=${endDate}`);
        if (response.data && response.data.data) {
            setStats(response.data.data);
        }
    };

    useEffect(() => {
        loadStats();
    }, [dateRange]);

    return (
        <>
            <h3 className={ styles.title }>Statistics</h3>
            <div className={ styles.container }>
                <div className={ styles.statBox }>
                    <Link to="/equipment/platforms" className='w-100'>
                        <div className={ `alma-box w-100 m-0` }>
                            <div className={ styles.statBody }>
                                <div className={ styles.statIcon }><FaCog /></div>
                                <div className={ styles.statContent }>
                                    <div className={ styles.statValue }>{ stats.platforms }</div>
                                    <h3 className={ styles.statLabel }>Platforms</h3>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={ styles.statBox }>
                    <Link to="/equipment/applicators" className='w-100'>
                        <div className={ `alma-box w-100 m-0` }>
                            <div className={ styles.statBody }>
                                <div className={ styles.statIcon }><FaCog /></div>
                                <div className={ styles.statContent }>
                                    <div className={ styles.statValue }>{ stats.applicators }</div>
                                    <h3 className={ styles.statLabel }>Applicators</h3>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={ styles.statBox }>
                    <Link to="/clinics" className='w-100'>
                        <div className={ `alma-box w-100 m-0` }>
                            <div className={ styles.statBody }>
                                <div className={ styles.statIcon }><FaClinicMedical /></div>
                                <div className={ styles.statContent }>
                                    <div className={ styles.statValue }>{ stats.clinics }</div>
                                    <h3 className={ styles.statLabel }>Clinics</h3>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className={ styles.statBox }>
                    <Link to="/service" className='w-100'>
                        <div className={ `alma-box w-100 m-0` }>
                            <div className={ styles.statBody }>
                                <div className={ styles.statIcon }><FaUserMd /></div>
                                <div className={ styles.statContent }>
                                    <div className={ styles.statValue }>{ stats.service_calls }</div>
                                    <h3 className={ styles.statLabel }>User Calls</h3>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                <div className={ styles.statBox }>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaSync /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.platforms_toupdate }</div>
                                <h3 className={ styles.statLabel }>Needs Update</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={ styles.statBox }>
                    <div className={ `alma-box w-100 m-0` }>
                        <div className={ styles.statBody }>
                            <div className={ styles.statIcon }><FaPowerOff /></div>
                            <div className={ styles.statContent }>
                                <div className={ styles.statValue }>{ stats.platforms_offline }</div>
                                <h3 className={ styles.statLabel }>Platforms Offline</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DistributorStats;
